import userApi from './user'
import articleApi from './article'
import uploadApi from './upload'
import homeApi from './home'

/**
 * API接口统一出口
 */
export default {
  user: userApi,
  article: articleApi,
  upload: uploadApi,
  home: homeApi
} 